import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ngisense/P4D/Parts4Drive/packages/eve-chat/node_modules/next/dist/client/app-dir/link.js");
